module.exports = {
  "country": "HU",
  "artist": "Joci Pápái",
  "song": "Origo",
  "year": "2017",
  "place": "9",
  "spotify": "2BbohoCr2keaPLxXycf34T"
};